import { axiosInventoryInstance } from '@/config/apiConfig';
import { AxiosResponse } from 'axios';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import { IFetchReconciliation, IReconciliation } from './reconciliation.type';

// Define the Location interface representing the structure of the user object returned by the API

export const fetchReconcilitions = ({
  page,
  limit,
  operatorId,
  startDate,
  endDate,
  type,
  order,
  orderBy,
  dateFilterBy,
}: IFetchReconciliation): Promise<AxiosResponse<IReconciliation[], any>> => {
  return axiosInventoryInstance({
    url: API_URL_CONFIG.RECONCILIATION.GET_RECONCILIATION,
    params: {
      page,
      limit,
      operatorId,
      ...(type ? { type } : {}),
      ...(startDate ? { startDate } : {}),
      ...(endDate ? { endDate } : {}),
      ...(order ? { order } : {}),
      ...(orderBy ? { orderBy } : {}),
      ...(dateFilterBy ? { dateFilterBy } : {}),
    },
  });
};
